import React from 'react'
import { Button, Text, VStack } from '@chakra-ui/react'
import Link from 'next/link'
import WarrantyPageLayout from './warranty-page-layout'
import RouterUrl from '@constants/router.constant'
import useGA4DataLayer from '@common/hooks/use-ga4-data-layer'

const WARRANTY_OPTIONS = [
  {
    label: 'Retail / Online Partner',
    href: RouterUrl.WARRANTY_PARTNERS,
    gtm: 'retail_online_partner'
  },
  {
    label: 'JML Direct Purchase',
    href: RouterUrl.WARRANTY_DIRECT,
    gtm: 'jml_direct_purchase'
  }
]

const Warranty = () => {
  const { warrantySelectTag } = useGA4DataLayer()
  return (
    <WarrantyPageLayout
      title="Warranty Registration"
      breadcrumbs={[
        { label: 'Home', href: RouterUrl.HOME.ROOT },
        { label: 'Warranty' }
      ]}
    >
      <VStack spacing={6} w={'100%'} maxW={'520px'} mx={'auto'}>
        <Text textStyle={'tcText'} w={'100%'} textAlign={'center'}>
          Thank You For Shopping With JML!
        </Text>
        <Text w={'100%'} textAlign={'center'} color={'red'} fontWeight={600}>
          Warranty coverage is not valid for non-electrical products.
        </Text>
        <Text textStyle={'tcText'} w={'100%'} textAlign={'center'}>
          Please select where you have made your purchase from:
        </Text>
        <VStack spacing={5} w={'100%'} pt={2}>
          {WARRANTY_OPTIONS.map((opt) => (
            <Link
              key={opt.href}
              href={opt.href}
              style={{ width: '100%' }}
              onClick={() => warrantySelectTag(opt.gtm, opt.href)}
            >
              <Button
                w={'100%'}
                h={'56px'}
                borderRadius={0}
                bg={'#DE4800'}
                color={'white'}
                fontSize={'18px'}
                _hover={{ bg: '#c23f00' }}
              >
                {opt.label}
              </Button>
            </Link>
          ))}
        </VStack>
      </VStack>
    </WarrantyPageLayout>
  )
}

export default Warranty
